import { TemplatePage } from '@/components/layout/TemplatePage'
import html from './template/About.html?raw'

export function About() {
  return <TemplatePage html={html} />
}
